import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./components/Login";
import Callback from "./components/Callback";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/callback"
          element={<Callback />}
        />
        <Route
          path="/login"
          element={<Login />}
        />
        <Route
          path="/"
          element={<Login />}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
